import { render, staticRenderFns } from "./LightBox.vue?vue&type=template&id=5ec952a6"
import script from "./LightBox.vue?vue&type=script&lang=ts"
export * from "./LightBox.vue?vue&type=script&lang=ts"
import style0 from "./LightBox.vue?vue&type=style&index=0&id=5ec952a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports